import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "18850TmghVNNrVT5VtbESDD", "Typewriter", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, Label } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu;
var Typewriter = (_dec = menu("act/Typewriter"), ccclass(_class = _dec(_class = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Typewriter, _Component);

  function Typewriter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_baseStr", "");

    _defineProperty(_assertThisInitialized(_this), "_curStr", "");

    _defineProperty(_assertThisInitialized(_this), "_index", 0);

    _defineProperty(_assertThisInitialized(_this), "_lbl", null);

    _defineProperty(_assertThisInitialized(_this), "_deltaCount", 0);

    _defineProperty(_assertThisInitialized(_this), "_deltaBaseCount", 6);

    _defineProperty(_assertThisInitialized(_this), "_shinkTimes", 0);

    _defineProperty(_assertThisInitialized(_this), "_shinkCount", 0);

    _defineProperty(_assertThisInitialized(_this), "_isAct", false);

    _defineProperty(_assertThisInitialized(_this), "_strArr", []);

    _defineProperty(_assertThisInitialized(_this), "_finishCall", null);

    _defineProperty(_assertThisInitialized(_this), "_pageIndex", 0);

    return _this;
  }

  var _proto = Typewriter.prototype;

  _proto.start = function start() {
    this._lbl = this.node.getComponent(Label);
    this._lbl.string = "";
  };

  _proto.act = function act(str, speed, pageIndex, finshCall) {
    if (speed === void 0) {
      speed = 6;
    }

    if (pageIndex === void 0) {
      pageIndex = 0;
    }

    if (finshCall === void 0) {
      finshCall = null;
    }

    if (!str) return;
    this._pageIndex = pageIndex;
    this._finishCall = finshCall;
    this._isAct = true;
    this._baseStr = str;

    if (speed == 6) {
      this._strArr = str.split(" ");
    } else {
      this._strArr = str.split("");
    }

    this._curStr = "";
    this._index = 0;
    this._shinkTimes = 0;
    this._deltaCount = 0;
    this._deltaBaseCount = speed;
    this._shinkCount = 0;
  };

  _proto.update = function update(dt) {
    if (!this._isAct) return;

    if (this._deltaCount == 0) {
      var aimstr = "";

      if (this._deltaBaseCount == 6) {
        aimstr = this._curStr == "" ? this._strArr[this._index] : this._curStr.substr(0, this._curStr.length - 1) + " " + this._strArr[this._index];
      } else {
        aimstr = this._curStr == "" ? this._strArr[this._index] : this._curStr.substr(0, this._curStr.length - 1) + this._strArr[this._index];
      }

      this._curStr = aimstr + ".";
      this._lbl.string = " " + this._curStr;

      if (this._curStr.length == this._baseStr.length + 1) {
        this._isAct = false;
        this._finishCall && this._finishCall(this._pageIndex);

        var _aimstr = this._curStr.substr(0, this._curStr.length - 1);

        this._curStr = _aimstr + " ";
        this._lbl.string = " " + this._curStr;
        return;
      }

      this._index++;
      this._deltaCount = this._deltaBaseCount;
    } else {
      this._deltaCount--;
    }

    if (this._shinkCount == 0 && this._curStr != "") {
      this._shinkTimes++;

      var _aimstr2 = this._curStr.substr(0, this._curStr.length - 1);

      if (this._shinkTimes % 2 == 0) {
        this._curStr = _aimstr2 + " ";
      } else {
        this._curStr = _aimstr2 + ".";
      }

      this._lbl.string = " " + this._curStr + " ";
      this._shinkCount = 20;
    } else {
      this._shinkCount--;
    }
  };

  return Typewriter;
}(Component), _temp)) || _class) || _class);
export { Typewriter as default };

_cclegacy._RF.pop();